import { forEach } from 'lodash'

// Function used as custom PostCSS filter.
// Used to remove duplicate CSS properties.
export default function removeDuplicateProperties( root, result ) {
	return ( root, result ) => {
		root.walkRules( function( rule ) {
			// All the properies:
			// { 'font-size': array( positionIndex, positionIndex, ... )  }
			const propertiesFound = {}

			rule.walkDecls( function( declaration, index ) {
				if ( ! ( declaration.prop in propertiesFound ) ) {
					propertiesFound[ declaration.prop ] = []
				}

				propertiesFound[ declaration.prop ].push( index )
			} )

			let duplicates = []

			// Check every property for repetition.
			forEach( propertiesFound, function( property ) {
				if ( 1 < property.length ) {
					// Add duplicate indexes into array.
					duplicates = duplicates.concat( property )
					// Remove the last element of the array (last propery to leave).
					duplicates.pop();
				}
			} )

			// Remove all duplicate properties (as children nodes of the rule).
			forEach( duplicates, function( duplicateIndex ) {
				rule.removeChild( duplicateIndex );
			} )
		} )
	}
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/postcss/postcss-remove-duplicate-properties.js